export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as unknown as ScrollBehavior });
  }, [pathname]);

  return null;
}